export default __webpack_public_path__ + "static/media/b37.a121bc8c.png";